import { createTheme } from '@targetx/mineral-ui/themes';

export default createTheme({
  overrides: {
    borderRadius_4: '0.5em'
  }
});
